(()=>{
const d=document,b=d.body;
const rm=matchMedia('(prefers-reduced-motion: reduce)').matches;
const fine=matchMedia('(pointer:fine)').matches;

/* smooth scroll */
if(window.Lenis&&!rm){
  try{
    const L=new Lenis({lerp:.11,smoothWheel:true,anchors:{offset:-70}});
    const raf=t=>{L.raf(t);requestAnimationFrame(raf)};requestAnimationFrame(raf);
    d.querySelectorAll('.drawer,.dr-items,dialog,.mnav').forEach(e=>e.setAttribute('data-lenis-prevent',''));
    const sync=()=>{(b.classList.contains('lock')||b.classList.contains('cart-open')||d.querySelector('dialog[open]'))?L.stop():L.start()};
    const mo=new MutationObserver(sync);
    mo.observe(b,{attributes:true,attributeFilter:['class']});
    d.querySelectorAll('dialog').forEach(g=>mo.observe(g,{attributes:true,attributeFilter:['open']}));
    window.__lenis=L;
  }catch(e){}
}

/* footer letters stagger index */
d.querySelectorAll('.ftr-word span').forEach((s,i)=>s.style.setProperty('--i',i));

/* marquee that reacts to scroll speed + hero parallax */
const tracks=rm?[]:[...d.querySelectorAll('.mq-track')].map(t=>{t.style.animation='none';return{t,x:0,w:0,vis:true}});
const measure=()=>tracks.forEach(o=>{o.w=o.t.scrollWidth/2});
measure();addEventListener('resize',measure);addEventListener('load',measure);
if('IntersectionObserver' in window)tracks.forEach(o=>new IntersectionObserver(([e])=>{o.vis=e.isIntersecting}).observe(o.t));
const hero=d.querySelector('.hero');
const chs=hero?[...hero.querySelectorAll('.hero-word .ch')]:[];
const art=hero?hero.querySelector('.hero-art'):null;
const sp=[.10,.24,.06,.19,.13,.28];
let py=scrollY,vel=0,dir=1;
const loop=()=>{
  const y=scrollY,dv=y-py;py=y;vel+=(dv-vel)*.18;
  if(Math.abs(dv)>.6)dir=dv>0?1:-1;
  const s=(.7+Math.min(Math.abs(vel),70)*.32)*dir;
  tracks.forEach(o=>{if(!o.vis||!o.w)return;o.x-=s;if(o.x<=-o.w)o.x+=o.w;if(o.x>0)o.x-=o.w;o.t.style.transform='translate3d('+o.x.toFixed(2)+'px,0,0)'});
  if(chs.length&&y<innerHeight*1.4){
    chs.forEach((c,i)=>{c.style.transform='translate3d(0,'+(-y*sp[i%sp.length]).toFixed(1)+'px,0)'});
    if(art)art.style.transform='translate3d(0,'+(y*.2).toFixed(1)+'px,0)';
  }
  requestAnimationFrame(loop);
};
if(!rm)requestAnimationFrame(loop);

/* magnetic buttons */
if(fine&&!rm)d.querySelectorAll('.btn').forEach(el=>{
  el.addEventListener('mousemove',e=>{const r=el.getBoundingClientRect();el.style.transform='translate('+(((e.clientX-r.left)/r.width-.5)*14).toFixed(1)+'px,'+(((e.clientY-r.top)/r.height-.5)*10).toFixed(1)+'px)'});
  el.addEventListener('mouseleave',()=>{el.style.transform=''});
});

/* delivery estimate */
const addDays=(dt,n)=>{const x=new Date(dt);let k=0;while(k<n){x.setDate(x.getDate()+1);if(x.getDay()!==0)k++}return x};
const fmt=x=>x.toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short'});
d.querySelectorAll('[data-eta]').forEach(el=>{
  const now=new Date();const ship=addDays(now,now.getHours()<14?1:2);
  el.textContent='Order now, ships by '+fmt(ship)+'. Arrives '+fmt(addDays(ship,2))+' to '+fmt(addDays(ship,5))+'.';
});

/* flats outside the hero draw when seen */
if('IntersectionObserver' in window){
  const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}}),{threshold:.25});
  d.querySelectorAll('.flat[data-draw]').forEach(f=>io.observe(f));
}else d.querySelectorAll('.flat[data-draw]').forEach(f=>f.classList.add('is-in'));

/* dialogs: draw flats inside when opened */
d.querySelectorAll('[data-dlg-open]').forEach(btn=>btn.addEventListener('click',()=>{const g=d.getElementById(btn.dataset.dlgOpen);if(g)setTimeout(()=>g.querySelectorAll('.flat').forEach(f=>f.classList.add('is-in')),60)}));
})();
